import { Skeleton } from '@/components/ui';

/**
 * Mirrors the structure of {@link WithdrawForm} so the layout doesn't
 * shift when the wallet balance + Pay.com saved cards resolve.
 */
export function WithdrawFormSkeleton() {
  return (
    <div className="flex flex-col gap-6" aria-busy="true" aria-live="polite">
      <div className="flex flex-col items-center gap-4 py-4">
        <Skeleton className="h-5 w-32 rounded" />
        <Skeleton className="h-[72px] w-48 rounded-card" />
      </div>

      <div className="flex flex-col gap-2">
        <Skeleton className="h-5 w-28 rounded" />
        <Skeleton className="h-12 w-full rounded-pill" />
      </div>

      <div className="flex flex-col gap-2">
        <Skeleton className="h-5 w-36 rounded" />
        <div className="grid grid-cols-2 gap-2.5">
          <Skeleton className="h-[52px] rounded-[40px]" />
          <Skeleton className="h-[52px] rounded-[40px]" />
          <Skeleton className="h-[52px] rounded-[40px]" />
          <Skeleton className="h-[52px] rounded-[40px]" />
        </div>
      </div>

      <Skeleton className="h-[52px] w-full rounded-tab" />
    </div>
  );
}
